import { FC, useEffect } from "react"
import { FormattedMessage } from "react-intl"

import ErrorModal from "./ErrorModal"

interface Props {
  refreshTime: number
  closeModal: () => void
}

const QuotaLimitReachedErrorModal: FC<Props> = ({
  refreshTime,
  closeModal,
}) => {
  useEffect(() => {
    if (!refreshTime) {
      closeModal()
    }
  }, [refreshTime])

  return (
    <ErrorModal closeModal={closeModal}>
      <FormattedMessage
        id="chat.rateLimitRefreshTime"
        defaultMessage="Oops! You've reached your chat message limit. You can send another message in {refreshTime} seconds."
        values={{ refreshTime }}
      />
    </ErrorModal>
  )
}

export default QuotaLimitReachedErrorModal
